const lightbox = (lbContainer) => {
    const expDay = parseInt(lbContainer.dataset.expiryDay);
    const timeToShowString = lbContainer.dataset.timeShow;
    const scrollToShowString = lbContainer.dataset.scrollShow;
    const blockTitle = lbContainer.dataset.blockTitle;
    const pageName = lbContainer.dataset.pageName;
    const localStorageSaveName = `lb${blockTitle}`;
    const nowTime = Date.now();
    const expiryLength = expDay * 24 * 60 * 60 * 1000;
    const localStorageExpiry = localStorage.getItem(`${localStorageSaveName}exp`);
    const localStorageTitle = localStorage.getItem(`${localStorageSaveName}title`);

    const showLightbox = () => {
        localStorage.setItem(`${localStorageSaveName}exp`, nowTime + expiryLength);
        localStorage.setItem(`${localStorageSaveName}title`, blockTitle);

        if (timeToShowString) {
            const timeToShow = parseInt(timeToShowString);

            const showShowing = timeToShow * 1000 - 100;
            const showShow = timeToShow * 1000;
    
            setTimeout(() => {
                lbContainer.classList.add("showing");
            }, showShowing);
    
            setTimeout(() => {
                lbContainer.classList.add("show")
            }, showShow);
        } else if (scrollToShowString) {
            const scrollToShow = parseInt(scrollToShowString) * 0.01;

            const pageHeight = window.innerHeight;
            const documentHeight = document.body.scrollHeight;
            const availableScrollHeight = documentHeight - pageHeight;
            const scrollTarget = scrollToShow * availableScrollHeight;
            const scrollFunction = throttle(() => {

                if (window.scrollY >= scrollTarget) {
                    lbContainer.classList.add("showing");

                    setTimeout(() => {
                        lbContainer.classList.add("show");
                    }, 100)

                    window.removeEventListener("scroll", scrollFunction);
                }

            }, 100)

            window.addEventListener("scroll", scrollFunction);
        }
    }

    if (localStorageTitle) {
        if (localStorageExpiry) {
            if (nowTime < parseInt(localStorageExpiry)) {
                if (localStorageTitle === blockTitle) {
                    return;
                } else {
                    showLightbox();
                }
            } else {
                showLightbox();
            }
        } else {
            showLightbox();
        }
    } else {
        showLightbox();
    }

    const closeButton = lbContainer.querySelector('.lightbox__close');

    lbContainer.addEventListener('click', (e) => {
        if (e.target === lbContainer || e.target === closeButton) {
            lbContainer.classList.remove("showing");
            lbContainer.classList.remove("show");
        }
    });
}

const throttle = (func, delay) => {
    let prev = 0;
    return (...args) => {
        let now = new Date().getTime();

        if (now - prev > delay) {
            prev = now;
            return func(...args);
        }
    }
}

export { lightbox };